function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_724_36)"
}, React.createElement("path", {
  d: "M12.6901 0.674988C13.8101 0.674988 14.8834 0.803322 15.9101 1.05999C16.9367 1.31666 17.9167 1.72499 18.8501 2.28499C19.8067 2.84499 20.5884 3.63832 21.1951 4.66499C21.8251 5.66832 22.2101 6.85832 22.3501 8.23499H18.1851C17.7651 5.59832 16.0267 4.27999 12.9701 4.27999C11.5234 4.27999 10.3684 4.59499 9.50507 5.22499C8.66507 5.83166 8.24507 6.67166 8.24507 7.74499C8.24507 8.63166 8.56007 9.31999 9.19007 9.80999C9.82007 10.3 10.7884 10.6733 12.0951 10.93L15.1051 11.525C17.4851 11.9917 19.2701 12.7383 20.4601 13.765C21.6501 14.7917 22.2451 16.2267 22.2451 18.07C22.2451 20.2867 21.3934 22.0833 19.6901 23.46C18.0101 24.8133 15.7934 25.49 13.0401 25.49C10.1001 25.49 7.7084 24.755 5.86507 23.285C4.04507 21.7917 3.03007 19.7733 2.82007 17.23H6.98507C7.19507 18.63 7.8484 19.7383 8.94507 20.555C10.0651 21.3717 11.5117 21.78 13.2851 21.78C14.7317 21.78 15.8634 21.5 16.6801 20.94C17.5201 20.3567 17.9401 19.5633 17.9401 18.56C17.9401 16.9967 16.7734 16.0167 14.4401 15.62L10.5201 14.85C6.04007 14.01 3.80007 11.7583 3.80007 8.09499C3.80007 5.87832 4.60507 4.09332 6.21507 2.73999C7.8484 1.36332 10.0067 0.674988 12.6901 0.674988Z",
  fill: "currentColor"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d_724_36",
  x: 0.820068,
  y: 0.674988,
  width: 27.53,
  height: 32.815,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dx: 2,
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_724_36"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_724_36",
  result: "shape"
})));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    style: {
      "transform": "translate(2px, 4px)"
    }
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/text-shadow.aea8d384.svg";
export { SvgComponent as ReactComponent };